{
    const main = function (e: Event) {
        // collect all artemis-form elements
        const formElements: NodeListOf<HTMLDivElement> = document.querySelectorAll(
            '.artemis-form-element:not(.artemis-form-element-hidden)'
        )
        // assign pos num (if pos is set to auto)
        let pos = 1
        formElements.forEach(formElement => {
            const posMatch = formElement.className.match(
                /(?:^|\s)(?<class>artemis-form-element-pos-(?<posvalue>auto|\d+))(?:$|\s)/
            )
            if (posMatch === null || posMatch.groups?.posvalue === 'auto') {
                // remove artemis-form-element-pos-auto if is set
                if (posMatch?.groups?.class)
                    formElement.classList.remove(posMatch.groups.class)
                formElement.classList.add(`artemis-form-element-pos-${pos++}`)
            } else if (posMatch.groups?.posvalue) {
                // update pos if artemis-form-element-pos-n is set
                pos = parseInt(posMatch.groups.posvalue) + 1
            }
        })
    }

    window.addEventListener('DOMContentLoaded', main)
}